// extracted by mini-css-extract-plugin
export var additionalIcon = "alpaquita-module--additionalIcon--d58e2";
export var additionalInformation = "alpaquita-module--additionalInformation--adada";
export var additionalTitle = "alpaquita-module--additionalTitle--20feb";
export var diagram = "alpaquita-module--diagram--1baaf";
export var dot = "alpaquita-module--dot--fd7b1";
export var products = "alpaquita-module--products--8631a";
export var promo = "alpaquita-module--promo--ffa8d";
export var promoContent = "alpaquita-module--promoContent--3e83d";
export var textBlock = "alpaquita-module--text-block--4d853";
export var textH2 = "alpaquita-module--text-h2--801bd";
export var textMl2 = "alpaquita-module--text-ml2--ecd63";
export var textP = "alpaquita-module--text-p--8afac";
export var textP2 = "alpaquita-module--text-p2--1990e";